import { z } from 'zod'

/**
 * How an event was linked to a GoHighLevel opportunity. Mirrors the `GhlLinkVia`
 * enum in the Prisma schema (`check:enums`). See docs/gohighlevel.spec.md.
 */
export const GHL_LINK_VIAS = ['picked_on_create', 'linked_by_hand', 'backfill_email', 'backfill_clef', 'review_confirmed'] as const

export const ghlLinkViaSchema = z.enum(GHL_LINK_VIAS)

export type GhlLinkVia = z.infer<typeof ghlLinkViaSchema>

/**
 * How the backfill itself links an event. Confirming a review is
 * `review_confirmed`, which a person does, not the run.
 */
export const GHL_BACKFILL_VIAS = ['backfill_email', 'backfill_clef'] as const satisfies readonly GhlLinkVia[]

export type GhlBackfillVia = (typeof GHL_BACKFILL_VIAS)[number]

/** Words for an event's link history: "Linked by Jane Doe (picked when creating the event)". */
export const GHL_LINK_VIA_LABEL: Record<GhlLinkVia, string> = {
  picked_on_create: 'picked when creating the event',
  linked_by_hand: 'linked by hand',
  backfill_email: 'matched by email',
  backfill_clef: 'matched by Clef',
  review_confirmed: 'confirmed from the review list',
}
